/** 신고 사유 — 백엔드 ReportReason 과 1:1. (대화방 신고 창도 같은 목록을 쓴다) */
export const REPORT_REASONS: { value: string; label: string }[] = [
    { value: 'ABUSE', label: '욕설/비방/혐오' },
    { value: 'SPAM', label: '스팸/광고/도배' },
    { value: 'ADULT', label: '음란물/불건전한 만남' },
    { value: 'ILLEGAL', label: '불법 정보/사기' },
    { value: 'PRIVACY', label: '개인정보 노출' },
    { value: 'FALSE_INFO', label: '허위사실/거짓 정보' },
    { value: 'OTHER', label: '기타' },
];
